import { CardContent, Divider } from "@mui/material";
import React from "react";
import { useLang } from "~/hooks/useLang";

interface FormTitleProps {
  readonly title: string;
  readonly description?: string | null
}

export default function FormGroupTitle({ title, description }: FormTitleProps) {
    const { translate } = useLang();
  
  return (
      <CardContent>
        <Divider sx={{ mb: 2 }}>
          {translate(title)}
        </Divider>
      </CardContent>
  )
}